import { Text, HStack, Avatar, Box, rem } from '@vimeo/bokeh';

import { Pictures, User } from './types';

export interface UserProfileProps {
  user: User;
}

export const UserProfile = ({ user }: UserProfileProps) => {
  return (
    <HStack>
      <HStack
        spacing="50"
        {...(user.link && {
          as: 'a',
          href: user.link,
          'aria-label': `Link to ${user.name} user profile`,
          _focusVisible: {
            outlineOffset: '2px',
            outlineColor: 'blue.500',
          },
        })}
      >
        <Box
          sx={{
            img: {
              width: rem(16),
              height: rem(16),
            },
          }}
        >
          <Avatar
            alt={user.name}
            loading="lazy"
            size="xs"
            {...getAvatarImages(user?.pictures?.sizes)}
          />
        </Box>

        <Text variant="body-sm" color="text-primary" noOfLines={1}>
          {user.name}
        </Text>
      </HStack>
    </HStack>
  );
};

export const UserAvatar = ({ user }: UserProfileProps) => (
  <Avatar alt={user.name} size="xs" {...getAvatarImages(user?.pictures?.sizes)} />
);

// Get URLs of video author's normal sized and 2X profile pictures
const getAvatarImages = (pix?: Pictures['sizes']) => {
  const defaultSrc = 'https://i.vimeocdn.com/portrait/default-blue_40x40';
  const defaultSrcSet = 'https://i.vimeocdn.com/portrait/default-blue_80x80';
  const size1x = 72;
  const size2x = 144;

  const src = pix?.find((p) => p.width === size1x)?.link || pix?.[1]?.link || defaultSrc;
  const srcSet = pix?.find((p) => p.width === size2x)?.link || pix?.[2]?.link || defaultSrcSet;

  return { src, srcSet: `${srcSet} 2x` };
};
